import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TermsService {
  private http = inject(HttpClient);

  private _baseUrl = '/api/terms';

  search(query: string): Observable<string[]> {
    return this.http.get<string[]>(`${this._baseUrl}`, { params: { query } });
  }
}
